import { useState } from 'react';

const initialState = {
  proposal: {
    id: 0,
    schoolName: '',
    businessManager: '',
    phoneNumber: '',
    booklistType: '',
    email: '',
    salesRep: {
      id: 0,
    },
    schoolLogoUrl: '',
    financialYear: '',
    status: '',
    createdDate: '',
    updatedDate: '',
    deadlineForFreeDelivery: '',
    orderBeforeDate: '',
    deliveryCommencementDate: '',
    expectedDeliveryDate: '',
    username: '',
    password: '',
    deliveryFee: '',
  },
  logo: null,
};

const useBtsSchoolModel = () => {
  const [btsSchool, setBtsSchool] = useState(initialState);

  const resetBtsSchool = () => {
    setBtsSchool(initialState);
  };

  return { btsSchool, setBtsSchool, resetBtsSchool, initialState };
};

export default useBtsSchoolModel;
